import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type ExpressOrder as SchemaExpressOrder } from '../schemas/ExpressOrder';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 */
export const CreateExpressOrderContentType = '' as const;
export type CreateExpressOrderRequest = undefined;
export type CreateExpressOrderResponses = LinkCommonErrorResponses & {
    /**
     * @description Express Order created
     */
    '200': {
        'application/json': SchemaExpressOrder;
    };
};
export type CreateExpressOrderResponseSuccess = CreateExpressOrderResponses['200']['application/json'];
export type CreateExpressOrderSearchParams = {
    host: string;
    offer_id: string;
    quantity: string;
    metric_client_id?: string;
    src?: string;
    data: string;
};
export type CreateExpressOrderPathParameters = undefined;
export const CreateExpressOrderUrl = '/express' as const;
export const CreateExpressOrderMethod = 'POST' as const;
export const getCreateExpressOrderUrl = (_params?: CreateExpressOrderPathParameters) => CreateExpressOrderUrl;
